import actions from './actions';
import getReducerByDocument from '../../../../../components/logs/reducer';

export default getReducerByDocument(actions);
